// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1BCnk","col":"CardReaderDesc_col__2s80K","label":"CardReaderDesc_label__1VBUL"};